import { Navigate } from 'react-router-dom';
import { useOnboarding } from '../contexts/OnboardingContext';
import { fetchApi } from '../api/fetch';
import { WizardStep1Email } from './onboarding/WizardStep1Email';
import { WizardStep2Digest } from './onboarding/WizardStep2Digest';

// Dev-only "reset onboarding" affordance — small, unobtrusive, top-right.
// Backed by POST /v1/onboarding/reset which returns 404 in production, so
// the button vanishes here AND would 404 there even if it didn't.
function DevResetButton({ onReset }: { onReset: () => void }) {
  if (!import.meta.env.DEV) return null;
  return (
    <button
      onClick={async () => {
        if (!confirm('Reset onboarding state? Wizard tasks (welcome/fallback/email-reply) will be deleted.')) {
          return;
        }
        try {
          await fetchApi('/onboarding/reset', { method: 'POST', body: JSON.stringify({}) });
          onReset();
        } catch (err) {
          console.warn('[OnboardingWizard] reset failed', err);
        }
      }}
      title="Dev only: reset onboarding state"
      className="fixed top-2 right-3 z-50 text-[10px] font-mono uppercase tracking-wider text-zinc-500 hover:text-primary-500 transition-colors"
    >
      reset
    </button>
  );
}

export function OnboardingWizard() {
  const { wizardComplete, emailDone, isLoading, refetch } = useOnboarding();

  if (isLoading) return null;

  if (wizardComplete) return <Navigate to="/app" replace />;

  return (
    <>
      <DevResetButton onReset={refetch} />
      {!emailDone ? <WizardStep1Email /> : <WizardStep2Digest />}
    </>
  );
}
